<template>
  <v-container fluid :style="{height:'100%', 'background-color':pageElements[$route.name].color}">
    <v-layout row wrap>
      <v-flex xs12>
        <v-img :src="pageElements[$route.name].img" height="100px" contain></v-img>
      </v-flex>

      <v-flex sm12 md9>
        <v-card ma-5 height="100%" min-height="350px">
          <v-card-title>
            <span class="headline">Autocorrect</span>
          </v-card-title>

          <v-card-text>
            <v-text-field
              @keyup="autocorrect"
              @input="debounceAutocomplete"
              @keydown.tab.prevent="chooseFirstSuggestion"
              v-model="text"
              ref="keyboardField"
              :append-outer-icon="'send'"
              :prepend-icon="icon"
              box
              clear-icon="close"
              clearable
              label="Text"
              type="text"
              :loading="autocorrectLoading"
              @click:clear="clearText"
            ></v-text-field>
          </v-card-text>
          <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" top>
            <template v-slot:activator="{ on }">
              <v-layout row wrap>
                <v-flex xs12 text-xs-left>
                  <v-btn :color="pageElements[$route.name].color" flat v-on="on">Configure</v-btn>
                </v-flex>
              </v-layout>
            </template>

            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6 md4>
                    <v-checkbox label="Enable Autocomplete" v-model="enableAutocomplete"></v-checkbox>
                  </v-flex>

                  <v-flex xs6 md4>
                    <v-checkbox label="Enable Autocorrect" v-model="enableAutocorrect"></v-checkbox>
                  </v-flex>

                  <v-flex xs6 md4>
                    <v-checkbox
                      label="Enable Next Word Prediction"
                      v-model="enableNextWordPrediction"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs6 md4>
                    <v-select
                      v-model="autocorrectMethod"
                      :items="autocorrectMethods"
                      label="Autocorrect Method"
                    ></v-select>
                  </v-flex>

                  <v-flex xs6 md4>
                    <v-select
                      v-model="autocompleteMethod"
                      :items="autocompleteMethods"
                      label="Autocomplete Method"
                    ></v-select>
                  </v-flex>

                  <v-flex xs6 md4>
                    <v-text-field
                      v-model="numSuggestions"
                      attach
                      type="number"
                      min="0"
                      max="100"
                      label="Number of Suggestions"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs6 md4 v-if="autocompleteMethod=='sampling'">
                    <v-text-field
                      v-model="temperature"
                      attach
                      type="number"
                      min="0"
                      max="10"
                      step="0.05"
                      label="Sampling Temperature"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs6 md4 v-if="autocompleteMethod=='beamsearch'">
                    <v-text-field
                      v-model="lookahead_words"
                      attach
                      type="number"
                      min="0"
                      max="20"
                      label="Beam Search Lookahead"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs6 md4 v-if="autocompleteMethod=='beamsearch'">
                    <v-text-field
                      v-model="beam_width"
                      attach
                      type="number"
                      min="0"
                      max="100"
                      label="Beam Search Width"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs6 md4>
                    <v-text-field
                      v-if="keyboardConfig.kwargs"
                      v-model="keyboardConfig.kwargs.run_id"
                      attach
                      label="Model ID"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-menu>
          <v-spacer></v-spacer>
          <template v-if="enableAutocomplete">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-progress-circular v-if="autocompleteLoading" indeterminate color="grey"></v-progress-circular>

                  <v-chip
                    v-else
                    v-for="(suggestion,i) in autocompleteSuggestions"
                    :key="i"
                    @click="clickSuggetion(suggestion)"
                  >{{suggestion.word}}</v-chip>
                </v-flex>
              </v-layout>
            </v-card-text>
          </template>
        </v-card>
      </v-flex>
      <v-flex sm12 md3>
        <v-card ma-5 height="100%">
          <infobox :explanation="pageElements[$route.name].explanation" :infos="keyboardInfos"></infobox>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import Infobox from "@/components/common/Infobox.vue";

export default {
  name: "keyboard",
  components: { Infobox },
  props: {},
  data() {
    return {
      menu: false,
      text: "",
      // enableNextWordPrediction: false,
      stopcharsRegex: /[.,"\/#!?$%\^&\*;:{}=\-_`~() ]/g,
      enableAutocorrect: true,
      enableAutocomplete: true,
      autocorrectData: null,
      numSuggestions: 3,
      lookahead_words: 3,
      temperature: 0.5,
      beam_width: 10,
      autocompleteMethod: "top",
      autocompleteMethods: ["sampling", "top", "beamsearch"],
      autocorrectMethod: "compound",
      autocorrectMethods: ["segmentation", "compound"],
      autocompleteLoading: false,
      autocorrectLoading: false,
      autocompleteSuggestions: []
    };
  },
  computed: {
    ...mapGetters("keyboard", {
      keyboardConfig: "keyboardConfig"
    }),
    ...mapGetters("common", {
      pageElements: "pageElements",
      keyboardInfos: "keyboardInfos"
    }),
    icon() {
      return "";
    },
    enableNextWordPrediction() {
      return true;
    }
  },
  methods: {
    ...mapActions("keyboard", {
      autocorrectText: "autocorrectText",
      getKeyboardSettings: "getKeyboardSettings",
      autocompleteText: "autocompleteText"
    }),
    clearText() {
      this.text = "";
    },
    strDiff(text, checkpointText) {
      var result = [],
        longerLength = a1.length >= a2.length ? a1.length : a2.length;
      for (i = 0; i < longerLength; i++) {
        if (a1[i] !== a2[i]) {
          result.push(i);
        }
      }
      return result;
    },
    strDiff2(a, b) {
      a = a.split("");
      b = b.split("");

      var indices = [];

      var value = a.filter(function(i) {
        if (b.indexOf(i) < 0) {
          indices.push(a.indexOf(i));
          return true;
        } else {
          return false;
        }
      });

      return { value: value.join(""), indices: indices };
    },
    cleanWord(word) {
      let badWords = ["ass"];
      return badWords.indexOf(word) < 0;
    },
    autocomplete() {
      if (!this.text || this.text.trim() === "") {
        this.autocompleteSuggestions = [];
        return;
      }
      let textEndsWithStopChar = this.text
        .slice(-1)[0]
        .match(this.stopcharsRegex);

      if (!textEndsWithStopChar && !this.enableAutocomplete) {
        return;
      }
      if (textEndsWithStopChar && !this.enableNextWordPrediction) {
        return;
      }

      let self = this;
      self.autocompleteLoading = true;
      self
        .autocompleteText({
          temperature: this.temperature,
          text: this.text,
          autocompleteMethod: this.autocompleteMethod,
          numSuggestions: this.numSuggestions,
          autocompleteConfig: this.keyboardConfig,
          options: {
            beam_width: this.beam_width,
            lookahead_words: this.lookahead_words
          }
        })
        .then(function(results) {
          self.autocompleteSuggestions = results.data.filter(function(item) {
            return self.cleanWord(item.word);
          });
          self.autocompleteLoading = false;
        });
    },
    clickSuggetion(suggestion) {
      this.text = suggestion.new_text + " ";
      this.autocomplete();
    },
    chooseFirstSuggestion() {
      if (
        this.autocompleteSuggestions &&
        this.autocompleteSuggestions.length > 0
      ) {
        this.clickSuggetion(this.autocompleteSuggestions[0]);
      }
    },
    debounceAutocomplete: _.debounce(function() {
      this.autocomplete();
    }, 300),
    autocorrect(event) {
      if (!this.enableAutocorrect) {
        return;
      }
      let self = this;
      let cursorPosition =
        this.$refs.keyboardField.$el.querySelector("input").selectionStart - 1;

      let correctionStart = 0;
      // if it ends with a stop char, we consider autocorrecting
      if (event.key.match(self.stopcharsRegex)) {
        let nonStopCharsFound = false;
        for (var i = cursorPosition; i >= 0; i--) {
          console.log(self.text[i]);
          if (!self.text[i].match(self.stopcharsRegex)) {
            // we found some non-stop characters
            nonStopCharsFound = true;
          } else {
            // we found a new stopping character but with text after it
            if (nonStopCharsFound) {
              correctionStart = i + 1;
              break;
            }
            // we found a new stopping character without text after it to correct (i.e. multiple consectuive stop chars)
            else if (i < cursorPosition) {
              return;
            }
          }
        }
      } else {
        return;
      }

      let textToCorrect = self.text.slice(correctionStart, cursorPosition);

      console.log("correctionStart: " + correctionStart);
      console.log("cursorPosition: " + cursorPosition);
      console.log("correct: " + textToCorrect);

      self.autocorrectData = null;
      self.autocorrectLoading = true;

      self.autocorrectText({ text: textToCorrect }).then(function(results) {
        self.autocorrectData = results.data;

        let corrected_string = textToCorrect;

        try {
          if (self.autocorrectMethod === "segmentation") {
            corrected_string =
              self.autocorrectData.segmentation.corrected_string;
          } else {
            corrected_string = self.autocorrectData.lookup[0].term;
          }
        } catch (error) {}

        self.text =
          self.text.slice(0, correctionStart) +
          corrected_string +
          self.text.slice(cursorPosition);
        if (corrected_string !== textToCorrect) {
          console.log("autocomplete trigger");
          self.debounceAutocomplete();
        }
        self.autocorrectLoading = false;
      });
    }
  },
  created() {},
  mounted() {
    let self = this;

    self.getKeyboardSettings();
  }
};
</script>

<style>
</style>
